const scheduleRouter = [
    {
        path:'',
        name:'schedule-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/schedule/index.vue'),
    },{
        path:'create',
        name:'schedule-create',
        component: () => import(/* webpackChunkName: "about" */ '../views/schedule/create.vue')
    },{
        path:'edit',
        name:'schedule-edit',
        component: () => import(/* webpackChunkName: "about" */ '../views/schedule/edit.vue')
    },
  ]
  export default scheduleRouter

  